import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/business/leads/templates/")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/sales/leads/templates", search, replace: true });
    },
});
